import type { GaApp } from '~/modules/app'

import { mainStore as main } from './main'
import { menuStore as menu } from './menu'
import { modalsStore as modals } from './modals'
import { ratingStore as rating } from './rating'
import { sourcesStore as sources } from './sources'
import { userStore as user } from './user'

export const stores = (gaApp: GaApp) => {
  return {
    main: main(gaApp),
    modals: modals(gaApp),
    user: user(gaApp),
    rating: rating(gaApp),
    menu: menu(gaApp),
    sources: sources(gaApp),
  }
}
